// extracted by mini-css-extract-plugin
export default {"contentAlign":"main_contentAlign__JWQ9k","loggedInSiteInfo":"main_loggedInSiteInfo__etuF7","siteInfo":"main_siteInfo__SLR+O","siteInfoTitle":"main_siteInfoTitle__aiOct"};